export const BRAND = {
  name: "ROYALE",
  full: "( Royale ) Thai Therapeutic Massage",
  fresha: "https://fresha.com/q/7sNfQDDq0XP02w",
  phoneDisplay: "+34 623 55 29 49",
  phoneHref: "tel:+34623552949",
  email: "Royalegspot@gmail.com",
  whatsapp:
    "https://wa.me/34623552949?text=Hola%20Royale%2C%20me%20gustar%C3%ADa%20reservar%20una%20sesi%C3%B3n%20de%20masaje.",
  address: "Carrer de la Constitució 24, 08014 Sants-Montjuïc, Barcelona",
  mapsEmbed:
    "https://maps.google.com/maps?q=Carrer%20de%20la%20Constituci%C3%B3%2024%2C%2008014%20Barcelona&t=&z=16&ie=UTF8&iwloc=&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Carrer+de+la+Constituci%C3%B3+24%2C+08014+Barcelona",
  googleReviews:
    "https://www.google.com/maps/search/Royale+Thai+Therapeutic+Massage+Carrer+de+la+Constitucio+24+Barcelona",
};

export const PHOTOS = {
  storefront: "/photos/storefront.webp",
  room: "/photos/room.jpeg",
  lounge: "/photos/lounge.webp",
  tea: "/photos/tea.jpeg",
  hall: "/photos/hall.jpeg",
};

export const REVIEWS_SEED = [
  { text: "Regina is very professional. On time, great communication, and an amazing therapist. A lovely person, and I had the best massage. Would definitely book again", date: "2025-02-07", rating: 5 },
  { text: "Very nice and professional massage :)", date: "2025-11-22", rating: 5 },
  { text: "I discovered Regina last year for a first massage, since we meet each week, her kindest, her hands are the best, she offer a real moment of physical well being and mental relax and reset. My only problem … I have to share her talent with other lucky patients ))) . Namaste !!", date: "2024-05-19", rating: 5 },
  { text: "I was in such a pain that I randomly look for someone close to my house that could make me feel better. I was so lucky to find Regina. She is such a professional, sweet and warm. I am now her forever customer, do not hesitate to ping her, she will go to your house and you will feel so good after her visit. Thank you a lot, Regina!", date: "2024-02-17", rating: 5 },
  { text: "Very puntual girl... All I can say is it's a perfect gift for myself... A combination of sports and relaxing massage is perfect for a very tiring week... 2hands are up for Regina very accommodating and she knows what she's doing", date: "2024-01-28", rating: 5 },
  { text: "Excellent massage, kindness, professionalism and punctuality. I had the pleasure to experience it 3 times already and I can't wait to schedule the next appointment. The 2-hours massages are highly recommended.", date: "2023-04-10", rating: 5 },
];

const IMG = {
  relajante:
    "https://images.unsplash.com/photo-1706795033849-7ca391f007c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  thai:
    "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  extendido:
    "https://images.unsplash.com/photo-1570174006382-148305ce4972?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  candle:
    "https://images.unsplash.com/photo-1643122966676-29e8597257f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  espalda:
    "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facial:
    "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const TREATMENTS = [
  {
    id: "masaje-relajante-1h",
    image: IMG.relajante,
    duration: "1 h",
    price: 65,
    tag: { es: "El más reservado", en: "Most booked" },
    title: { es: "Masaje Relajante", en: "Relaxing Massage" },
    desc: {
      es: "Un tratamiento corporal suave y envolvente que libera la tensión muscular y devuelve la calma a cuerpo y mente.",
      en: "A smooth, enveloping full-body treatment that releases muscular tension and restores calm to body and mind.",
    },
  },
  {
    id: "masaje-thai-balines-1h15",
    image: IMG.thai,
    duration: "1 h 15 min",
    price: 70,
    tag: { es: "Firma Royale", en: "Royale signature" },
    title: { es: "Masaje Thai Balinés", en: "Thai Balinese Massage" },
    desc: {
      es: "Fusión ancestral de estiramientos pasivos tailandeses y presiones rítmicas balinesas para revivir tu energía.",
      en: "Ancestral fusion of passive Thai stretches and rhythmic Balinese pressure to revive your energy.",
    },
  },
  {
    id: "masaje-relajante-1h30",
    image: IMG.extendido,
    duration: "1 h 30 min",
    price: 95,
    tag: { es: "Inmersión total", en: "Deep immersion" },
    title: { es: "Masaje Relajante Extendido", en: "Extended Relaxing Massage" },
    desc: {
      es: "La sesión larga de relajación total: aceites aromáticos cálidos, presión en puntos clave y un descanso profundo.",
      en: "The long session of total relaxation: warm aromatic oils, work on key pressure points and deep rest.",
    },
  },
  {
    id: "masaje-con-bella-1h30",
    image: IMG.candle,
    duration: "1 h 30 min",
    price: 110,
    tag: { es: "Ritual de lujo", en: "Luxury ritual" },
    title: { es: "Masaje con Bella (Candle Ritual)", en: "Bella Candle Ritual Massage" },
    desc: {
      es: "Ritual sensorial exclusivo con cera tibia aromática: nutre la piel mientras disuelve el cansancio más profundo.",
      en: "Exclusive sensory ritual with warm aromatic candle wax: it nourishes the skin while dissolving deep fatigue.",
    },
  },
  {
    id: "royale-oriental-espalda-30m",
    image: IMG.espalda,
    duration: "30 min",
    price: 38,
    tag: { es: "Alivio express", en: "Express relief" },
    title: { es: "Royale Oriental (Espalda)", en: "Royale Oriental (Back Relief)" },
    desc: {
      es: "Terapia focalizada en cuello, hombros y espalda para soltar contracturas y el estrés del día en media hora.",
      en: "Focused therapy for neck, shoulders and back — releases knots and daily stress in half an hour.",
    },
  },
  {
    id: "royale-facial-30m",
    image: IMG.facial,
    duration: "30 min",
    price: 38,
    tag: { es: "Luminosidad", en: "Glow booster" },
    title: { es: "Royale Facial", en: "Royale Facial" },
    desc: {
      es: "Tratamiento facial revitalizante con masaje drenante para devolver la luminosidad natural a tu rostro.",
      en: "Revitalizing facial treatment with a draining massage to bring back your face's natural radiance.",
    },
  },
];

export const UI = {
  es: {
    nav: {
      treatments: "Tratamientos",
      gallery: "La Galería",
      contact: "Contacto",
      book: "Reservar en Fresha",
    },
    hero: {
      eyebrow: "Barcelona · Masaje Thai y Terapéutico",
      title: "ROYALE",
      subtitle: "Masaje Thai Terapéutico",
      tagline: "Cuida tu Cuerpo · Piel y Alma",
      sub: "Escapa a un santuario de sanación tailandesa antigua, aceites cálidos y lujo silencioso en el corazón de Barcelona.",
      book: "Reservar en Fresha",
      whatsapp: "Reservar por WhatsApp",
      ask: "¿Dudas? Llámanos",
      hours: "Lun–Sáb 12:00–21:00 · Dom cerrado",
      scroll: "Desliza",
    },
    services: {
      eyebrow: "Tratamientos Firma",
      title: "Cuidado para Cuerpo, Piel y Alma",
      sub: "Cada ritual se realiza con intención — combinando la técnica tailandesa tradicional con un toque terapéutico cálido para disolver el día a día. Precios de nuestra agenda Fresha.",
      book: "Reservar este ritual",
      bookAll: "Ver agenda completa en Fresha",
      waBook: "Reservar por WhatsApp",
    },
    gallery: {
      eyebrow: "La Galería",
      title: "Un Vistazo por Dentro",
      sub: "Momentos de calma en nuestro santuario de Sants-Montjuïc — así te espera Royale.",
      captions: {
        storefront: "Nuestra fachada",
        lounge: "El rincón de espera",
        tea: "Té de bienvenida",
        hall: "El pasillo de las velas",
        cta: "Tu momento de calma te espera",
        ctaBtn: "Reservar ahora",
      },
    },
    contact: {
      eyebrow: "Visita Royale",
      title: "Encuéntranos y Reserva",
      sub: "Estamos en el corazón de Sants-Montjuïc, Barcelona. Reserva tu momento de calma en Fresha o escríbenos por WhatsApp.",
      hoursTitle: "Horario de Apertura",
      days: "Lunes – Sábado",
      hoursVal: "12:00 – 21:00",
      sunday: "Domingo",
      closed: "Cerrado",
      call: "Llámanos",
      wa: "WhatsApp",
      waNote: "Respuesta rápida en horario de apertura",
      book: "Reservar en Fresha",
      directions: "Abrir en Google Maps",
      addressLabel: "Dirección",
      emailLabel: "Email",
    },
    footer: {
      tagline: "Masaje thai & terapéutico en Sants-Montjuïc, Barcelona.",
      bookNote: "Reservas online al instante con Fresha",
      rights: "Todos los derechos reservados.",
    },
  },
  en: {
    nav: {
      treatments: "Treatments",
      gallery: "Gallery",
      contact: "Contact",
      book: "Book on Fresha",
    },
    hero: {
      eyebrow: "Barcelona · Thai & Therapeutic",
      title: "ROYALE",
      subtitle: "Thai Therapeutic Massage",
      tagline: "Care for your Body · Skin & Soul",
      sub: "Escape into a sanctuary of ancient Thai healing, warm oils and quiet luxury in the heart of Barcelona.",
      book: "Book on Fresha",
      whatsapp: "Book via WhatsApp",
      ask: "Any questions? Call us",
      hours: "Mon–Sat 12:00–21:00 · Sun closed",
      scroll: "Scroll",
    },
    services: {
      eyebrow: "Signature Treatments",
      title: "Care for Body, Skin & Soul",
      sub: "Each ritual is performed with intention — blending traditional Thai technique with warm, therapeutic touch to melt away the everyday. Prices from our Fresha menu.",
      book: "Book this ritual",
      bookAll: "See full diary on Fresha",
      waBook: "Book via WhatsApp",
    },
    gallery: {
      eyebrow: "The Gallery",
      title: "A Glimpse Inside Royale",
      sub: "Moments of stillness in our Sants-Montjuïc sanctuary — this is how Royale awaits you.",
      captions: {
        storefront: "Our storefront",
        lounge: "The waiting corner",
        tea: "Welcome tea",
        hall: "The candle hallway",
        cta: "Your moment of calm awaits",
        ctaBtn: "Book now",
      },
    },
    contact: {
      eyebrow: "Visit Royale",
      title: "Find Us & Book",
      sub: "We're in the heart of Sants-Montjuïc, Barcelona. Reserve your moment of calm on Fresha or message us on WhatsApp.",
      hoursTitle: "Opening Hours",
      days: "Monday – Saturday",
      hoursVal: "12:00 – 21:00",
      sunday: "Sunday",
      closed: "Closed",
      call: "Call us",
      wa: "WhatsApp",
      waNote: "Fast reply during opening hours",
      book: "Book on Fresha",
      directions: "Open in Google Maps",
      addressLabel: "Address",
      emailLabel: "Email",
    },
    footer: {
      tagline: "Thai & therapeutic massage in Sants-Montjuïc, Barcelona.",
      bookNote: "Instant online booking with Fresha",
      rights: "All rights reserved.",
    },
  },
};
